import { gql } from '@apollo/client';

/** 与后端 PermissionMutation.addPermissionPackage 一致 */
export const ADD_PERMISSION_PACKAGE = gql`
  mutation AddPermissionPackage($input: PermissionPackageApiRequestInput!) {
    addPermissionPackage(input: $input) {
      success
      message
      messageCode
      data {
        id
        name
        description
        resources
      }
    }
  }
`;

export interface PermissionPackageApiRequestInput {
  id?: number | null;
  name: string;
  description?: string | null;
  resourceCodes?: string[];
}
